import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { loadBizBrand ,loadBizBrandSuccess, loadBizBrandFailure } from './biz-brand.action';
import { ApiResponse } from '../../models/common.model';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class BizBrandEffects {
  constructor(private actions$: Actions, private http: HttpClient, private customerService: CustomerService) { }

  loadBizBrand$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBizBrand),
      switchMap((action) => {
        return this.customerService.getBizBrandList()
          .pipe(
            map((response: ApiResponse) => loadBizBrandSuccess({ bizBrand: response.body })),
            catchError((error) => of(loadBizBrandFailure({ error })))
          );
      })
    )
  );
}